// javascript
import useConsent from '@lib/hooks/useConsent';

import PropTypes from 'prop-types';
import useContentElement from '../../hooks/useContentElement';

export default function EmbedElement(props) {
  const { data } = props;
  const hasConsent = useConsent('youtube');

  const { elementData } = useContentElement(
    data,
    EmbedElement.dataSchema,
  );

  const {
    provider,
    url,
  } = elementData;
  const frameSrc = (url ?? '')
    .replace('/shorts/', '/embed/')
    .replace('https://youtu.be/', 'https://www.youtube.com/embed/')
    .replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/');

  if (!hasConsent) {
    return null;
  }

  return (
    <iframe
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      className={provider === 'youtube' ? 'player' : 'player-shorts'}
      loading="lazy"
      src={frameSrc}
      style={{ border: 0 }}
      title="YouTube video player"
    />
  );
}

const PROVIDER = [
  'youtube',
  'youtubeShorts',
];

EmbedElement.typeName = 'EmbedElement'; // Strapi element type
EmbedElement.propTypes = {
  data: PropTypes.shape({
    provider: PropTypes.oneOf(PROVIDER).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

EmbedElement.graphQlSchema = `
  id
  provider
  url
`;

function getYouTubeVideoId(url) {
  if (!url) return null;

  // v= parameter (watch?v=...)
  const vMatch = url.match(/[?&]v=([^&#]+)/);
  if (vMatch) return vMatch[1];

  // youtu.be short link
  const shortMatch = url.match(/youtu\.be\/([^?&#/]+)/);
  if (shortMatch) return shortMatch[1];

  // shorts URL: /shorts/{id}
  const shortsMatch = url.match(/\/shorts\/([^?&#/]+)/);
  if (shortsMatch) return shortsMatch[1];

  // embed URL: /embed/{id}
  const embedMatch = url.match(/\/embed\/([^?&#/]+)/);
  if (embedMatch) return embedMatch[1];

  return null;
}
